import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ContractDetailsViewModel, ContractBalancesViewModel } from '@models/Contract';
import { SpinnerPage, Breadcrumbs } from '@common/components';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { history } from 'src';
import { ContractBalanceTableComponent } from './contract-balance-table.component';
import { ContractBalancePaymentComponent } from './contract-balance-payment.component';
import { ContractCheckPaymentViewModel, PaymentType } from '@models/Payment';
import { OptionsViewModel } from '@models/common.models';

export interface ContractBalancesComponentProperties extends RouteComponentProps<{ id?: number }> {
  readonly contractDetailsVM: ContractDetailsViewModel;
  readonly balancesList: Array<ContractBalancesViewModel>;
  readonly selectedBalances: Array<ContractBalancesViewModel>;
  readonly paymentSources: Array<OptionsViewModel>;
  readonly getContractDetails: (id: number) => void;
  readonly getContractBalances: (id: number) => void;
  readonly handleSelectBalance: (balance: ContractBalancesViewModel) => void;
  readonly openCreditCardModal: (hostedCheckoutButton?: HTMLButtonElement | null) => void;
  readonly getPaymentSources: () => void;
  readonly saveCheckPayment: (checkPayment: ContractCheckPaymentViewModel) => void;
  readonly clearBalances: () => void;
}

export interface ContractBalancesComponentState {
  isPayment: boolean;
  paymentType: PaymentType;
  isSaving: boolean;
}

export class ContractBalancesComponent extends React.Component<
  ContractBalancesComponentProperties,
  ContractBalancesComponentState
> {
  launchButton: HTMLButtonElement | null = null;

  state: ContractBalancesComponentState = {
    isPayment: false,
    paymentType: PaymentType.None,
    isSaving: false
  };
  constructor(props: ContractBalancesComponentProperties) {
    super(props);
  }

  componentDidMount() {
    this.props.getPaymentSources();
    if (this.props.match && this.props.match.params.id) {
      this.props.getContractBalances(this.props.match.params.id);
      this.props.getContractDetails(this.props.match.params.id);
    }
  }

  componentWillUnmount() {
    this.props.clearBalances();
  }

  toggleRow(balance: ContractBalancesViewModel) {
    if (this.props.handleSelectBalance) {
      this.props.handleSelectBalance(balance);
    }
  }

  redirectToDetails = () => {
    if (this.props.match && this.props.match.params.id) {
      history.push(getRoute(RouteDefinitions.contract.Details, { id: +this.props.match.params.id }));
    }
  };

  setPaymentType = (paymentType: PaymentType) => {
    this.setState({ paymentType: paymentType });
  };

  handleSaveCheckPayment = (form: ContractCheckPaymentViewModel) => {
    this.setState({ isSaving: true });
    let checkPayment = { ...form } as ContractCheckPaymentViewModel;
    checkPayment.contractId = this.props.contractDetailsVM.id;
    checkPayment.balances = this.props.selectedBalances;
    this.props.saveCheckPayment(checkPayment);
  };

  render() {
    if (!this.props.balancesList || this.state.isSaving) {
      return <SpinnerPage />;
    } else {
      return (
        <>
          <Breadcrumbs />
          {!this.state.isPayment ? (
            this.props.balancesList.length > 0 ? (
              <div>
                <ContractBalanceTableComponent
                  balancesVM={this.props.balancesList}
                  selectedBalances={this.props.selectedBalances}
                  toggleRow={this.props.handleSelectBalance}
                />
                <div className="mt-15 col-md-12 text-right">
                  <button className="btn btn-secondary" onClick={this.redirectToDetails}>
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={!this.props.selectedBalances || this.props.selectedBalances.length < 1}
                    onClick={() => this.setState({ isPayment: true })}
                  >
                    Next
                  </button>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-xs-12">
                  <h3>No contract related balanaces at this time.</h3>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      history.push(
                        this.props.match && this.props.match.params.id
                          ? getRoute(RouteDefinitions.contract.Details, {
                              id: +this.props.match.params.id
                            })
                          : RouteDefinitions.dashboard
                      );
                    }}
                  >
                    View Contract Details
                  </button>
                </div>
              </div>
            )
          ) : (
            <div>
              <ContractBalancePaymentComponent
                contractDetailsVM={this.props.contractDetailsVM}
                selectedBalances={this.props.selectedBalances}
                paymentType={this.state.paymentType}
                paymentSources={this.props.paymentSources}
                setPaymentType={(paymentType: PaymentType) => this.setPaymentType(paymentType)}
                buttonRef={b => (this.launchButton = b)}
                startCreditCardPayment={() => this.props.openCreditCardModal(this.launchButton)}
                saveCheckPayment={(checkPayment: ContractCheckPaymentViewModel) =>
                  this.handleSaveCheckPayment(checkPayment)
                }
              />
              <div className="mt-15 col-md-12">
                <button
                  className="btn btn-secondary"
                  onClick={() => this.setState({ isPayment: false, paymentType: PaymentType.None })}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-balances/_components/contract-balances.component.tsx